export default __webpack_public_path__ + "static/media/dietly-desktop.97cd77a7.svg";